export type ISocialService = ReturnType<typeof socialServiceFactory>;
/* @ngInject */
export function socialServiceFactory($translate, wixSdk) {
  const urls = {
    facebook: '',
    twitter: '',
    track: '',
  };

  return {
    urls,
    updateArtistName,
  };

  function updateArtistName(name) {
    wixSdk.getSiteInfo(({ url }) => {
      $translate(['twitter-share-text', 'twitter-share-text-artist'], {
        name,
      }).then(translated => {
        const twitterText = name
          ? translated['twitter-share-text-artist']
          : translated['twitter-share-text'];

        urls.facebook = encodeURI(
          `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        );
        urls.twitter = encodeURI(
          `https://twitter.com/intent/tweet?text=${twitterText} ${url}`,
        );
        urls.track = encodeURI(
          `//www.bandsintown.com/${name ? `track/${name}` : ''}`,
        );
      });
    });
  }
}
